import { convertTo12Hour, getTimeInAmPmFormat } from "./formatDateTime";

export const capitalize = (str) =>
  typeof str === "string" ? str.charAt(0).toUpperCase() + str.slice(1) : str;

export const formatDate = (date) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};
export const getDiscountMeta = (original, discounted, type) => {
  if (!original || !discounted || discounted >= original) return null;

  const diff = original - discounted;

  if (type === "percentage") {
    const percent = (diff / original) * 100;
    return `${percent.toFixed(0)}% OFF`;
  }

  return `₹${Math.round(diff)} OFF`;
};

export const formatDateMonth = (date) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
  });
};

export const formatSlotDateTime = (date, slotTime) => {
  if (!date) return { date: "--", time: "--" };

  const d = new Date(date);
  const formattedDate = d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
  });

  if (!slotTime) {
    return { date: formattedDate, time: "--" };
  }

  return {
    date: formattedDate,
    time: `${convertTo12Hour(slotTime.start)} - ${convertTo12Hour(
      slotTime.end,
    )}`,
  };
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "—";

  const date = new Date(dateString);

  const hasTime =
    date.getHours() !== 0 || date.getMinutes() !== 0 || date.getSeconds() !== 0;

  const datePart = date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  if (!hasTime) {
    return datePart;
  }

  const timePart = date.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return `${timePart} · ${datePart}`;
};

export const formatBookingTimeInCol = (dateString) => {
  if (!dateString) return { time: null, date: "—" };

  const date = new Date(dateString);

  const hasTime =
    date.getHours() !== 0 || date.getMinutes() !== 0 || date.getSeconds() !== 0;

  const datePart = date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    // year: "numeric",
  });

  if (!hasTime) {
    return { time: null, date: datePart };
  }

  const timePart = date.toLocaleTimeString("en-IN", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return { time: timePart, date: datePart };
};

export const formatPaymentMethod = (method = "") => {
  const map = {
    UPI_QR: "UPI",
    PAY_AFTER_SERVICE: "Pay Later",
  };

  return map[method] || "—";
};

export const getFormattedBookingDateTime = ({
  slotAvailabilityId,
  slotSnapshot,
}) => {
  const date = slotAvailabilityId?.date || null;
  const formattedDate = date ? formatDate(date) : "—";
  const formattedSlotTime =
    slotSnapshot?.startTime && slotSnapshot?.endTime
      ? `${getTimeInAmPmFormat(slotSnapshot.startTime)} - ${getTimeInAmPmFormat(
          slotSnapshot.endTime,
        )}`
      : "—";

  return {
    date: formattedDate,
    slotTime: formattedSlotTime,
  };
};

export const buildPeriodRange = (period) => {
  const now = new Date();

  const to = new Date(now);
  to.setUTCHours(23, 59, 59, 999);

  const from = new Date(to);

  switch (period) {
    case "daily": {
      from.setUTCHours(0, 0, 0, 0);
      break;
    }

    case "weekly": {
      const day = from.getUTCDay(); // 0 = Sunday, 1 = Monday

      const diff = day === 0 ? 6 : day - 1;

      from.setUTCDate(from.getUTCDate() - diff);
      from.setUTCHours(0, 0, 0, 0);
      break;
    }

    case "monthly": {
      from.setUTCDate(1);
      from.setUTCHours(0, 0, 0, 0);
      break;
    }

    case "yearly": {
      from.setUTCMonth(0, 1); // Jan 1
      from.setUTCHours(0, 0, 0, 0);
      break;
    }

    default: {
      // fallback → treat as daily
      from.setUTCHours(0, 0, 0, 0);
    }
  }

  return {
    fromDate: from.toISOString(),
    toDate: to.toISOString(),
  };
};
